import React, { Component } from 'react';
import PropTypes from 'prop-types';
import buildContextMenu from './BuildContextMenu';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MaterialIconMenu from 'material-ui/IconMenu';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import * as Colors from 'material-ui/styles/colors';

export const topRight = { horizontal: 'right', vertical: 'top' };
const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
};

class ContextIconMenu extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            dialogOpen: false,
            dialogTitle: 'Delete',
            dialogMessage: '',
            item: null,
            deleteAction: () => {}
        };
    }

    render() {
        const { actions, data, ...props} = this.props;

        if (!actions || actions.length === 0) { return false; } // guard

        const deleteActions = actions.filter((e) => e !== undefined && e.type === 'deleteDialog');
        const updatedActions = actions.map(action => (action.type !== 'deleteDialog')
            ? action
            : ({
                label: action.menuTitle || 'Delete',
                icon: <DeleteIcon/>,
                condition: action.condition,
                action: () => this.setState({
                    dialogOpen: true,
                    dialogTitle: action.title,
                    dialogMessage: action.message,
                    item: action.value,
                    deleteAction: action.deleteAction
                })
            }));

        const menu = buildContextMenu(updatedActions, this.context.auth, data);
        return (menu.length > 0) && (
            <div>
                <MaterialIconMenu {...props} touchTapCloseDelay={1}>
                    {menu}
                </MaterialIconMenu>
                {deleteActions.length > 0 && (
                    <Dialog
                        key='dialog_1'
                        title={this.state.dialogTitle}
                        modal={false}
                        open={this.state.dialogOpen}
                        onRequestClose={() => this.setState({dialogOpen: false})}
                        actions={[
                            <FlatButton key="1" label="Cancel" onTouchTap={() => this.setState({dialogOpen: false})}/>,
                            <FlatButton key="2" label="Delete" onTouchTap={() => {
                                this.state.deleteAction(this.state.item);
                                this.setState({dialogOpen: false});
                            }}/>
                        ]}
                    >
                        {this.state.dialogMessage}
                    </Dialog>
                )}
            </div>
        );
    }
}

ContextIconMenu.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.object).isRequired,
    data:    PropTypes.object,

    menuStyle:          PropTypes.object,
    anchorOrigin:       PropTypes.object,
    targetOrigin:       PropTypes.object,
    iconButtonElement:  PropTypes.object,
};

ContextIconMenu.defaultProps = {
    menuStyle: style.menu,
    anchorOrigin: topRight,
    targetOrigin: topRight,
    iconButtonElement: (<IconButton touch={true} style={style.iconButton}>
        <MoreVertIcon  color={Colors.grey400} />
    </IconButton>)
};

ContextIconMenu.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default ContextIconMenu;
